var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(_setup.userId)?_c(_setup.TwoFactorVerificationForm,{attrs:{"user-id":_setup.userId,"login-token":_vm.loginToken,"message":_setup.message},on:{"back-to-login":_setup.goBackToLogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }